module.exports = __webpack_public_path__ + "566a158b40db4923b5d25038146bc052.png";